import { INewsStory } from '../../../shared/api/contentful/types/INewsStory';
import { useUrlForPageId } from '../../../app/pages/ui/utils/useUrlForPageId';
import { NewsPageId } from '../../../app/pages/domain/constants/PageId';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { getNewsroomShortcuts } from '../../helpers/getNewsroomShortcuts';

export type FinalSubmitHandler = (data: INewsStory) => void | Promise<void>;

export function useNewsroomShortcuts() {
	const { t } = useTranslation();
	const aviationDepartment =
		'https://www.charlottenc.gov/City-Government/Departments/Aviation';
	const mediaLibrary =
		'https://cltairport.intelligencebank.com/resource/folder/index/1f5e7d620057c0d606549053e959f1f0';

	const constructionProjects = useUrlForPageId(NewsPageId.ConstructionProjects);
	const stayConnected = useUrlForPageId(NewsPageId.StayConnected);

	const shortcuts = getNewsroomShortcuts(t, {
		aviationDepartment,
		stayConnected,
		mediaLibrary,
		constructionProjects,
	});

	return { shortcuts };
}
